Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.CapsStyle = module.exports.default = {
	NONE: "none",
	ROUND: "round",
	SQUARE: "square"
};